module.exports = __webpack_public_path__ + "img/warrantyBg.3fc78338.png";